import store from '@store'
// import _uniqBy from 'lodash/uniqBy'
// import _compact from 'lodash/compact'

const areaMap = {
  '雙北地區': ['台北市', '臺北市', '新北市'],
  '北部地區': ['基隆市', '新竹市', '桃園市', '新竹縣', '宜蘭縣'],
  '中部地區': ['台中市', '臺中市', '苗栗縣', '彰化縣', '南投縣', '雲林縣'],
  '南部地區': ['台南市', '臺南市', '高雄市', '嘉義市', '嘉義縣', '屏東縣', '澎湖縣'],
  '東部地區': ['台東市', '臺東縣', '花蓮縣'],
  '離島地區': ['金門縣', '連江縣']
};

export function cityAreaOptions(storeList = []) {
  const storeStoreList = storeList[0]
    ? storeList
    : storeOptions({
        type: 'open',
      });

  // const cityAreaMap = {
  //   '台北市': {
  //     title: '雙北地區',
  //     alias: 'taipei-city',
  //   },
  //   '新北市': {
  //     title: '雙北地區',
  //     alias: 'taipei-city',
  //   },
  //   '臺中市': {
  //     title: '台中地區',
  //     alias: 'taichung',
  //   },
  //   '桃園市': {
  //     title: '桃園地區',
  //     alias: 'taoyuan',
  //   },
  // };

  let AREA = new Set();

  storeStoreList.forEach(item => {
    const city = item.city;

    for (let areaName in areaMap) {
      if (areaMap[areaName].includes(city)) {
        AREA.add(areaName);
        break;
      }
    }
  });

  return [...AREA].map((item)=>({
    text: item,
    value: item
  }))

  /* return _compact(_uniqBy(storeStoreList.map(item => {
    const city = item.address.substr(0, 3);

    return cityAreaMap[city]
  }), 'alias'))
    .map(item => {
      return {
        text: item.title,
        value: item.alias
      }
    }); */
}

/**
 * 分店選項
 * @param storeList
 * @param type
 * @param storeType
 * @param storeArea
 * @param limit
 * @returns {(*&{text: *, value: *})[]}
 */
export function storeOptions({
  storeList = [],
  type = 'all',
  storeType = 'all',
  storeArea = 'all',
  limit = 9999,
} = {}) {
  // const cityMap = {
  //   'taipei-city': [
  //     '台北市',
  //     '新北市'
  //   ],
  //   'keelung': '基隆市',
  //   'lienchiang': '連江縣',
  //   'yilan': '宜蘭縣',
  //   'diauyutai': '釣魚臺',
  //   'hsinchu': [
  //     '新竹市',
  //     '新竹縣'
  //   ],
  //   'taoyuan': '桃園市',
  //   'miaoli': '苗栗縣',
  //   'taichung': '臺中市',
  //   'changhua': '彰化縣',
  //   'nantou': '南投縣',
  //   'chiayi': [
  //     '嘉義市',
  //     '嘉義縣'
  //   ],
  //   'yunlin': '雲林縣',
  //   'tainan': '臺南市',
  //   'kaohsiung': '高雄市',
  //   'nanhai': '南海島',
  //   'penghu': '澎湖縣',
  //   'kinmen': '金門縣',
  //   'pingtung': '屏東縣',
  //   'taitung': '臺東縣',
  //   'hualien': '花蓮縣',
  // };
  const storeStoreList = storeList[0]
    ? storeList
    : store.state.merchant.currentMerchant?.stores || [];
  const isDisabled = (item) => {
    return !item.state
  };

  const openStoreList = storeStoreList.filter(item => {
    return !isDisabled(item);
  });

  const closeStoreList = storeStoreList.filter(item => {
    return isDisabled(item);
  });

  const switchStoreList = () => {
    switch(type) {
      case "open":
        return openStoreList;
      case "close":
        return closeStoreList;
      case "all":
      default:
        return storeStoreList
    }
  };

  return switchStoreList()
    .filter(item => {
      return !storeType || storeType === 'all' || item.storeType === storeType;
    })
    .filter(item => {
      const city = item.city;
      return !storeArea || storeArea === 'all' || areaMap[storeArea].includes(city);
    })
    .map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
    .slice(0, limit)
}

/**
 * 寵物選項
 * @returns {{text: *, value: *}[]}
 */
export function categoryOptions() {
  const storePetCategories = store.state.merchant.currentMerchant?.petCategories || [];
  storePetCategories.filter(item => {
    return item.children
  });

  return storePetCategories.map(item => {
    return {
      ...item,
      text: item.title,
      value: item.alias
    }
  })
}

/**
 * 體型選項
 * @param category
 * @returns {*|*[]}
 */
export function sizeOptions(category) {
  const storePetCategories = store.state.merchant.currentMerchant?.petCategories || [];
  const sizeItem = category
    ? storePetCategories.filter(item => {
      return item.alias === category
    })
    : [];

  return sizeItem[0]?.children.map(item => {
    return {
      ...item,
      text: item.title,
      value: item.alias
    }
  }) || []
}

/**
 * 會員寵物選項
 * @param type
 * @param prepaidId
 * @returns {(*&{text: *, value: *})[]}
 */
export function memberPetOptions({ type = 'all', prepaidId } = {}) {
  const storeMemberPetList = store.state.auth?.currentMemberPetList || [];

  const sizeAliasList = () => {
    if(prepaidId) {
      const applicableEventList = getMemberApplicablePrepaidOption({
        value: prepaidId,
        key: 'prepaid.applicableEvents'
      })
        .filter(item => item.used < item.times);

      return applicableEventList.map(item => item.sizeAlias);
    } else {
      return []
    }
  };

  const isDisabled = (item) => {
    return prepaidId
      ? !sizeAliasList()
        .includes(item.sizeAlias)
      : false;
  };

  const openMemberPetList = storeMemberPetList.filter(item => {
    return !isDisabled(item);
  });

  const closeMemberPetList = storeMemberPetList.filter(item => {
    return isDisabled(item);
  });

  const switchMemberPetList = () => {
    switch(type) {
      case "open":
        return openMemberPetList;
      case "close":
        return closeMemberPetList;
      case "all":
      default:
        return storeMemberPetList
    }
  };

  return switchMemberPetList()
    .map(item => {
      return {
        ...item,
        text: item.name,
        value: item.id,
      }
    })
}

/**
 * 會員包套方案選項
 * @param prepaidOrderList
 * @param type [all, open, close]
 * @returns {(*&{disabled: boolean, text: string, store: *, value: *})[]}
 */
export function memberApplicablePrepaidOptions({ prepaidOrderList, type = 'all' } = {}) {
  const applicablePrepaidList = prepaidOrderList || (store.state.order?.currentApplicablePrepaidOrderList || []);

  const isDisabled = (item) => {
    return item.prepaid.stores.every(item => {
      return !item.state
    })
  };

  const openPrepaidList = applicablePrepaidList.filter(item => {
    return !isDisabled(item);
  });

  const closePrepaidList = applicablePrepaidList.filter(item => {
    return isDisabled(item);
  });

  const switchPrepaidList = () => {
    switch(type) {
      case "open":
        return openPrepaidList;
      case "close":
        return closePrepaidList;
      case "all":
      default:
        return [
          ...openPrepaidList,
          ...closePrepaidList
        ];
    }
  };

  return switchPrepaidList()
    .map(item => {
      const storeCloseText = isDisabled(item)
        ? '（分店暫停預約）'
        : '';

      return {
        ...item,
        text: `${storeCloseText}${item.prepaid.title} - 剩餘${item.times - item.used}次`,
        value: item.id,
        store: item.prepaid.stores[0],
        title: item.prepaid.title,
        disabled: isDisabled(item)
      }
    })
}

/**
 * 取得選項
 * @param options
 * @param value
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getOption({ options, value, type = 'key', key }) {
  const optionItems = options
    .filter(item => {
      return item.value === value
    });
  const defaultValue = type === 'key'
    ? ''
    : {};

  const optionValue = () => {
    const keyValue = () => {
      const keyParts = key.split(".");

      return key.indexOf('.') !== -1
        ? optionItems[0]?.[keyParts[0]]?.[keyParts[1]] || ''
        : optionItems[0]?.[key] || ''
    };

    return type === 'key' && key
      ? keyValue()
      : optionItems[0] || {};
  };

  return !optionItems[0]
    ? defaultValue
    : optionValue()
}

/**
 * 取的分店選項
 * @param value
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getStoreOption({ value, type = 'key', key }) {
  return getOption({
    options: storeOptions(),
    value,
    type,
    key
  })
}

/**
 * 取得分類選項
 * @param value
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getCategoryOption({ value, type = 'key', key }) {
  return getOption({
    options: categoryOptions(),
    value,
    type,
    key
  })
}

/**
 * 取得體型選項
 * @param value
 * @param pet
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getSizeOption({ value, category, type = 'key', key }) {
  return getOption({
    options: sizeOptions(category),
    value,
    type,
    key
  })
}

/**
 * 取得會員寵物選項
 * @param value
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getMemberPetOption({ value, type = 'key', key }) {
  return getOption({
    options: memberPetOptions(),
    value,
    type,
    key
  })
}

/**
 * 取得會員包套方案選項
 * @param value
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getMemberApplicablePrepaidOption({ value, type = 'key', key }) {
  return getOption({
    options: memberApplicablePrepaidOptions(),
    value,
    type,
    key
  })
}
